import { useState } from "react";
import { Quote, ChevronLeft, ChevronRight, Star } from "lucide-react";
import { testimonials } from "../../mock/mock";

const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const t = testimonials[idx];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-100 border border-amber-200 mb-4">
            <span className="text-xs font-semibold text-amber-800 tracking-widest uppercase">Testimonials</span>
          </div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-stone-800 mb-4">
            Our Happy <span className="text-orange-600">Parents</span>
          </h2>
          <p className="text-stone-600">Real stories from families who chose Aadi Gayanam for their little ones.</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-3xl p-8 md:p-12 shadow-lg border border-orange-100 relative">
            <Quote className="absolute top-6 right-6 w-16 h-16 text-orange-200" />
            <div className="flex items-center gap-1 mb-6">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 text-yellow-500 fill-yellow-500" />
              ))}
            </div>
            <p className="text-lg md:text-xl text-stone-700 leading-relaxed mb-8 italic">
              “{t.quote}”
            </p>
            <div className="flex items-center justify-between flex-wrap gap-4">
              <div className="flex items-center gap-4">
                <img src={t.image} alt={t.name} className="w-14 h-14 rounded-full object-cover border-2 border-orange-300" />
                <div>
                  <p className="font-display font-bold text-stone-800">{t.name}</p>
                  <p className="text-sm text-orange-700">{t.role}</p>
                </div>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => setIdx((idx - 1 + testimonials.length) % testimonials.length)}
                  className="w-10 h-10 rounded-full bg-white shadow hover:bg-orange-600 hover:text-white flex items-center justify-center transition-colors"
                >
                  <ChevronLeft className="w-5 h-5" />
                </button>
                <button
                  onClick={() => setIdx((idx + 1) % testimonials.length)}
                  className="w-10 h-10 rounded-full bg-white shadow hover:bg-orange-600 hover:text-white flex items-center justify-center transition-colors"
                >
                  <ChevronRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>
          <div className="flex justify-center gap-2 mt-6">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                className={`h-1.5 rounded-full transition-all ${i === idx ? "w-8 bg-orange-600" : "w-3 bg-orange-200"}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
